// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const GridApi = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new GridApi({
        dateFields: [
            'submissionDate',
            'failureDate',
            'repairDate',
            'creditMemoDate'
        ]
    });

export default GridApi;



// WEBPACK FOOTER //
// ./src/reports/claim-history/state/grid-api.js